/// <amd-module name="Artifacts/PackageRecycleBin/redux/Reducer" />

import {
  IInitLoadCompletedPayload,
  ISelectedDeletedPackagesPayload,
  PackageRecycleBinActionsUnion,
  PackageRecycleBinActionTypes as HubActionTypes,
} from "Artifacts/PackageRecycleBin/redux/Actions";
import { IPackageRecycleBinState } from "Artifacts/PackageRecycleBin/redux/Contracts";
import {
  LoadingComponentState,
  ReadyComponentState,
} from "Artifacts/Root/helpers/ComponentStateHelpers";
import { syncComponentState } from "Artifacts/Root/Redux";
import produce from "immer";

const initialState = (): IPackageRecycleBinState => ({
  componentState: LoadingComponentState(),
  emptyButtonState: ReadyComponentState(),
});

export const packageRecycleBinReducer = produce(
  (draft: IPackageRecycleBinState, action: PackageRecycleBinActionsUnion) => {
    syncComponentState(draft, "componentState", action, {
      loading: HubActionTypes.InitLoadStarted,
      ready: HubActionTypes.InitLoadCompleted,
      error: HubActionTypes.InitLoadFailed,
    });
    syncComponentState(draft, "emptyButtonState", action, {
      loading: HubActionTypes.EmptyRecycleBinStarted,
      ready: HubActionTypes.EmptyRecycleBinCompleted,
      error: HubActionTypes.EmptyRecycleBinFailed,
    });
    switch (action.type) {
      case HubActionTypes.InitLoadCompleted:
        draft.pkgVersions = (action.payload as IInitLoadCompletedPayload).pkgVersions;
        break;
      case HubActionTypes.FakeEmptyOnClient:
        // Fake the empty recycle bin client-side after successful empty operation
        draft.pkgVersions = [];
        break;
      case HubActionTypes.FakePackageRestore:
      case HubActionTypes.FakePackagePermanentDelete:
        fakeRemoveSelectedPackages(draft, action.payload as ISelectedDeletedPackagesPayload);
        break;
    }
    return draft;
  },
  initialState(),
);

function fakeRemoveSelectedPackages(
  draft: IPackageRecycleBinState,
  payload: ISelectedDeletedPackagesPayload,
): void {
  payload.selectedVersions.forEach((sv) => {
    const pkgVersionIndex = draft.pkgVersions?.findIndex(
      (p) => p.name === sv.name && p.version === sv.version,
    );

    if (pkgVersionIndex !== undefined && pkgVersionIndex >= 0) {
      draft.pkgVersions?.splice(pkgVersionIndex, 1);
    }
  });
}
